<template>
  <div class="section">
    <el-form>
      <el-form-item>
        <label style="color: #1890ff">XML：</label>
        <el-button type="primary" style="margin-left: 40%;" @click="toJson">确定</el-button>
      </el-form-item>
      <el-form-item style="flex-grow: 1">
        <origin-el-input v-model="xmlStr" type="textarea" />
      </el-form-item>
      <el-form-item>
        <label style="color: #1890ff">JSON：</label>
      </el-form-item>
      <el-form-item style="flex-grow: 1">
        <origin-el-input v-model="jsonStr" type="textarea" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Input as OriginElInput } from 'element-ui'
import x2js from 'x2js'

export default {
  name: 'XmlToJson',
  components: { OriginElInput },
  data() {
    return {
      xmlStr: '',
      jsonStr: ''
    }
  },
  methods: {
    toJson() {
      // eslint-disable-next-line new-cap
      const obj = new x2js().xml2js(this.xmlStr)
      this.jsonStr = JSON.stringify(obj)
    }
  }
}
</script>

<style lang="scss" scoped>
.section ::v-deep {
  .el-form {
    display: flex;
    flex-direction: column;
    height: 100%;
    .el-form-item {
      .el-form-item__content {
        height: 100%;
        .el-textarea {
          height: 100%;
          textarea {
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
